// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__lBqe8","colMin":"styles_colMin__KdhnZ","colCheckbox":"styles_colCheckbox__zVZmp"};